<template>
    <div class="flex flex-direction">
        <div class="member-set flex align-center  bg-white radius padding-sm">
<!--            <div @click="showAddEmployee('',false)">会员录入</div>-->
<!--            <div @click="dialogImprotUserVisible = true">会员导入</div>-->
            <div class="operate" @click="dialogDepartmentVisible = true">+ 添加部门</div>

        </div>
        <div class="flex flex-direction margin-top-sm  bg-white radius padding-lr-sm flex-sub">


            <div v-for="(item,index) in lists" :key="index" class="dept-item flex flex-direction">
                <div class="staff-department flex justify-between align-center" @click="onExpand(index)">
                    <div class="flex align-center">
                        <i  class="icon" :class="item.expand ? 'el-icon-caret-top' :'el-icon-caret-bottom'"></i>
                        <div class="dept-name margin-left-xs">{{ item.name }}({{ item.detail.length }}人)</div>
                    </div>
                    <div class="flex">
<!--                        <el-button size="mini" type="primary" @click.stop="showAddEmployee(item.id,false)">添加人员-->
<!--                        </el-button>-->
                        <el-button round type="danger" @click.stop="showDelDepartment(item.id)">删除部门</el-button>
                    </div>
                </div>
                <div v-if="item.expand">
                    <div v-for="(member,position) in item.detail"
                         :key="position" class="staff-member flex  align-center justify-between">
                        <div class="flex align-center">
                            <div class="memeber-name flex align-center">
                                <div class="flex align-center">
                                    <i class="memebr-avatar flex-shrink">{{ member.xingming.substr(member.xingming.length - 1) }}</i>
                                    <div class="name margin-left-xs">{{ member.xingming }}</div>
                                </div>
                            </div>
                            <div class=" flex justify-start">
                                <div class="memeber-info">{{ member.msex|sex }}</div>
                                <div class="memeber-info line">{{ member.phone }}</div>
                                <div class="memeber-info margin-left">{{ member.zhiwu }}</div>
                            </div>
                        </div>
<!--                        <div class="flex">-->
<!--                            <el-button size="mini" type="primary" @click="showMoveEmployee(item.id,member)">移动-->
<!--                            </el-button>-->
<!--                            <el-button size="mini" type="danger" @click="showAddEmployee(item.id,member)">修改</el-button>-->
<!--                            <el-button size="mini" type="success" @click="showPassEmployee(member)">初始化密码</el-button>-->
<!--                            <el-button size="mini" type="info" @click="showDelEmployee(member.id)">删除</el-button>-->
<!--                        </div>-->
                    </div>
                </div>
            </div>
            <el-empty description="暂无人员" v-if="!lists.length"></el-empty>
        </div>
        <el-dialog
            :before-close="handleClose"
            :show-close="false"
            :visible.sync="dialogDepartmentVisible"
            title="创建部门"
            width="380px">
            <div>
                <el-input v-model="d_title"
                          placeholder="请输入部门名称"></el-input>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="handleClose">取消</el-button>
                <el-button type="primary" @click="addDepartment()">确 定</el-button>
            </span>
        </el-dialog>
        <el-dialog
            :before-close="handleClose"
            :show-close="false"
            :visible.sync="dialogMoveEmployeeVisible"
            title="选择部门"
            width="30%">
            <div>
                <el-select v-model="m_bumen" placeholder="请选择部门">
                    <el-option
                        v-for="item in departments"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                    </el-option>
                </el-select>
                <el-input v-model="m_zhiwu" class="margin-top-sm"
                          placeholder="请输入职位"></el-input>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="handleClose">取消</el-button>
                <el-button type="primary" @click="moveEmployee()">确 定</el-button>
            </span>
        </el-dialog>
        <el-dialog
            :before-close="handleClose"
            :show-close="false"
            :visible.sync="dialogPassEmployeeVisible"
            title="初始化密码"
            width="30%">
            <div>
                <el-input v-model="r_pass" placeholder="请输入密码"
                          type="password"></el-input>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="handleClose">取消</el-button>
                <el-button type="primary" @click="resetPass()">确 定</el-button>
            </span>
        </el-dialog>
        <el-dialog
            :before-close="handleClose"
            :show-close="false"
            :visible.sync="dialogEmployeeVisible"
            title="创建账号"
            width="35%">
            <el-form ref="employeeForm" :model="employee" :rules="rules"
                     class="employee-form"
                     labelWidth="80px">
                <el-form-item label="账号" prop="phone">
                    <el-input
                        v-model="employee.phone"
                        placeholder="请输入手机号"
                    ></el-input>
                </el-form-item>
                <el-form-item label="姓名" prop="name">
                    <el-input v-model="employee.name" placeholder="请输入姓名"></el-input>
                </el-form-item>
                <el-form-item label="性别" prop="sex">
                    <el-select v-model="employee.sex" placeholder="请选择性别">
                        <el-option :value="1" label="男"></el-option>
                        <el-option :value="2" label="女"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="学历" prop="education">
                    <el-select v-model="employee.education" placeholder="请选择学历">
                        <el-option :value="1" label="专科及以下"></el-option>
                        <el-option :value="2" label="大学本科"></el-option>
                        <el-option :value="3" label="研究生及以上"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="出生日期" prop="birthday">
                    <el-date-picker
                        v-model="employee.birthday" placeholder="请选择出生日期"
                        style="width: 100%" type="date"
                        value-format="yyyy-MM-dd">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="入职时间" prop="inductionTime">
                    <el-date-picker
                        v-model="employee.inductionTime" placeholder="请选择入职时间"
                        style="width: 100%" type="date"
                        value-format="yyyy-MM-dd">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="部门" prop="bumen">
                    <el-select v-model="employee.bumen" placeholder="请选择部门">
                        <el-option
                            v-for="item in departments"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="职位" prop="zhiwu">
                    <el-input
                        v-model="employee.zhiwu"
                        placeholder="请输入职位"
                    ></el-input>
                </el-form-item>
                <el-form-item label="密码">
                    <el-input
                        v-model="employee.pass"
                        placeholder="请输入密码"
                        type="password"
                    ></el-input>
                </el-form-item>
                <div class="flex align-center justify-end">
                    <el-button @click="handleClose">取消</el-button>
                    <el-button type="primary" @click="submitDepartment('employeeForm')">确定</el-button>
                </div>
            </el-form>
        </el-dialog>
        <import-user-info :dialog-visible="dialogImprotUserVisible" @watchInfoState="watchInfoState"></import-user-info>
    </div>
</template>

<script>

import {
    addDepartment, addEmployee, delDepartment, delEmployee, editEmployee,
    listDepartment, moveEmployee, orgEmployeeList, resetPass
} from "@/api";
import {confirm, md5, TOAST, toast} from "@/utils/utils";
import ImportUserInfo from "@/views/web/components/ImprotUserInfo";
import rules from "@/utils/rules";

export default {
    name: "member_index",
    components: {ImportUserInfo},
    data() {
        return {
            searchName:'',
            searchPhone:'',
            lists: [],
            departments: [],
            d_title: '',//创建部门的名称
            dialogDepartmentVisible: false,
            cur_eid: '',
            employee: { //创建人员
                phone: '',
                name: '',
                sex: '',
                education: '',
                birthday: '',
                inductionTime: '',
                zhiwu: '',
                bumen: '',
                pass: '',
            },
            rules: {
                phone: [
                    {required: true, message: "请输入手机号", trigger: "blur"},
                     rules.phone
                ],
                name: [{required: true, message: "请输入姓名", trigger: "blur"}],
                sex: [{required: true, message: "请选择性别", trigger: "change"}],
                education: [{required: true, message: "请选择学历", trigger: "change"}],
                birthday: [{required: true, message: "请选择出生日期", trigger: "change"}],
                inductionTime: [{required: true, message: "请选择入职时间", trigger: "change"}],
                bumen: [{required: true, message: "请选择是否建立党组织", trigger: "change"}],
                zhiwu: [{required: true, message: "请输入职位", trigger: "blur"}],
                pass: [{required: true, message: "请输入密码", trigger: "blur"}],
            },
            dialogEmployeeVisible: false,
            m_bumen: '',//移动
            m_zhiwu: '',
            dialogMoveEmployeeVisible: false,
            r_pass: '',//修改密码
            dialogPassEmployeeVisible: false,
            dialogImprotUserVisible: false,
        }
    },
    computed: {
        user() {
            return this.$store.state.user
        }
    },
    created() {
        this.$emit('setIndex', [3,3], '部门管理')
        this.init()
    },
    methods: {
        async init() {
            let _departments = await listDepartment()
            this.departments = _departments.data
            this.getOrgEmployeeList()
        },
        async getOrgEmployeeList() {
            let _data = await orgEmployeeList(this.searchName,this.searchPhone)
            let _is_expand
            _data.data.map(item => {
                item.expand = !_is_expand && item.detail.length
                _is_expand = _is_expand || item.detail.length
            })
            this.lists = _data.data
        },
        async addDepartment() {
            if (!this.d_title) return  toast('请输入部门名称',TOAST.error)
            let _data = await addDepartment(this.d_title)
            if (_data.status === 200) {
                this.init()
                this.handleClose()
                toast(_data.msg)
            } else {
                toast(_data.msg,TOAST.error)
            }
        },
        showAddEmployee(bumen, item) {
            if (item) {
                this.cur_eid = item.id
                this.employee = { //创建人员
                    phone: item.phone,
                    name: item.xingming,
                    sex: Number(item.msex),
                    education: item.education,
                    birthday: item.birthday,
                    inductionTime: item.induction_time,
                    zhiwu: item.zhiwu,
                    bumen: bumen,
                    pass: '',
                }
            } else {
                this.employee = { //创建人员
                    phone: '',
                    name: '',
                    sex: '',
                    education: '',
                    birthday: '',
                    inductionTime: '',
                    zhiwu: '',
                    bumen: bumen,
                    pass: '',
                }
            }
            this.dialogEmployeeVisible = true
            this.$refs['employeeForm'].resetFields()
        },
        submitDepartment(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.addEmployee()
                }
            });
        },
        async addEmployee() {
            if (!this.employee.pass && !this.cur_eid) return  toast('请输入密码',TOAST.error)
            let _pass = md5(this.employee.pass).toUpperCase()
            let _data = this.cur_eid ? await editEmployee( this.cur_eid, this.employee.phone,
                    this.employee.name, this.employee.sex, this.employee.education, this.employee.birthday,
                    this.employee.inductionTime, this.employee.zhiwu, this.employee.bumen, _pass) :
                await addEmployee(this.employee.phone, this.employee.name, this.employee.sex,
                    this.employee.education, this.employee.birthday, this.employee.inductionTime, this.employee.zhiwu,
                    this.employee.bumen, _pass)
            if (_data.status === 200) {
                this.init()
                this.handleClose()
                toast(_data.msg)
            } else {
                toast(_data.msg,TOAST.error)
            }
        },
        showPassEmployee(item) {
            this.cur_eid = item.id
            this.dialogPassEmployeeVisible = true
        },
        async resetPass() {
            if (!this.r_pass) return  toast('请输入密码',TOAST.error)
            let _pass = md5(this.r_pass).toUpperCase()
            let _data = await resetPass(this.cur_eid, _pass)
            if (_data.status === 200) {
                this.handleClose()
                toast(_data.msg)
            } else {
                toast(_data.msg,TOAST.error)
            }
        },
        showMoveEmployee(bumen, item) {
            this.m_bumen = bumen
            this.m_zhiwu = item.zhiwu
            this.cur_eid = item.id
            this.dialogMoveEmployeeVisible = true
        },
        async moveEmployee() {
            if (!this.m_zhiwu) return  toast('请输入职务',TOAST.error)
            let _data = await moveEmployee(this.cur_eid, this.m_zhiwu, this.m_bumen)
            if (_data.status === 200) {
                this.init()
                this.handleClose()
                toast(_data.msg)
            } else {
                toast(_data.msg,TOAST.error)
            }
        },
        showDelEmployee(id) {
            confirm('删除提醒','您确定要删除？',()=>{
                this.delEmployee(id)
            },'确定',true)
        },
        async delEmployee(id) {
            let _data = await delEmployee(id)
            if (_data.status === 200) {
                this.init()
                toast(_data.msg)
            } else {
                toast(_data.msg,TOAST.error)
            }
        },
        showDelDepartment(id) {
            confirm('删除提醒','您确定要删除？删除之后部门所有人员将会清空',()=>{
                this.delDepartment(id)
            },'确定',true)
        },
        async delDepartment(id) {
            let _data = await delDepartment(id)
            if (_data.status === 200) {
                this.init()
                toast(_data.msg)
            } else {
                toast(_data.msg,TOAST.error)
            }
        },
        onExpand(index) {
            this.lists[index].expand = !this.lists[index].expand
        },
        handleClose() {
            this.d_title = ''
            this.dialogDepartmentVisible = false
            this.employee = { //创建人员
                phone: '',
                name: '',
                sex: '',
                education: '',
                birthday: '',
                inductionTime: '',
                zhiwu: '',
                bumen: '',
                pass: '',
            }
            this.dialogEmployeeVisible = false
            this.cur_eid = ''
            this.m_bumen = ''
            this.m_zhiwu = ''
            this.dialogMoveEmployeeVisible = false
            this.dialogPassEmployeeVisible = false
        },
        //  上传成功
        watchInfoState(data) {
            this.dialogImprotUserVisible = false
            if (data) {
                this.getOrgEmployeeList()
            }
        },
        search(){
            this.getOrgEmployeeList()
        },
        reset() {
            this.searchName = ''
            this.searchPhone = ''
            this.search()
        }
    },
    filters: {
        sex(type) {
            switch (Number(type)) {
                case 1:
                    return '男'
                case 2:
                    return '女'
                default:
                    ''
            }
        }
    },
}
</script>

<style lang="scss" scoped>


.dept-item{
    border-bottom: 1px solid #e6e9ec;
    padding-bottom: 10px;
    padding-top: 10px;
}
.staff-department{
    .dept-name{
        font-size: 18px;
        font-weight: 600;
        color: #0e325e;
        cursor: pointer;
        span{
            font-size: 14px;
            color: #666666;
            margin-left: 6px;
        }
    }
    .icon{
        font-size: 20px;
        color: #dae0e6;
    }

}
.staff-member + .staff-member{
    border-top: 1px solid #e6e9ec;
}
.staff-member {
    padding: 20px 0;
    margin-left: 30px;

    .memeber-name {
        width: 200px;
        .name{
            font-size: 18px;
            font-weight: 400;
            color: #333333;
        }
        .memebr-avatar {
            width: 26px;
            height: 26px;
            text-align: center;
            line-height: 26px;
            border-radius: 26px;
            background: #0a2240;
            color: white;
        }
    }

    .operate{
        height: 26px;
        background-color: #eff3f8;
        border-radius: 13px;
        font-size: 14px;
        line-height: 26px;
        padding: 0 12px;
        color: #0a2240;
        font-weight: normal;
        border: none;
    }

    .memeber-info {
        max-width: 150px;
        min-width: 60px;
        padding: 0 20px;
        font-size: 16px;
        color: #333333;
        text-align: center;
        &.line{
            border-left: 1px solid #f0f0f0;
            border-right: 1px solid #f0f0f0;
        }
    }
}

.el-select {
    width: 100%;
}

.member-set {
    .operate {
        width: 160px;
        height: 40px;
        line-height: 40px;
        text-align: center;
        background-image: linear-gradient(37deg, #ffb400 0%, #fc7802 100%),
        linear-gradient(#ff9600, #ff9600);
        background-blend-mode: normal, normal;
        border-radius: 20px;
        font-size: 14px;
        color: #ffffff;
        cursor: pointer;
    }
    .search-container{
        .input{
            /deep/.el-input__inner{
                width: 206px;
                height: 40px;
                background-color: #ffffff;
                border-radius: 10px;
                border: solid 1px #dae0e6;
            }
        }
        .search{
            width: 90px;
            height: 40px;
            background-color: #0a2240;
            border-radius: 10px;
            font-size: 14px;
            font-weight: normal;
            font-stretch: normal;
            letter-spacing: 0px;
            color: #ffffff;
        }
    }

}
</style>